import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./project-info.css";

export const Details = ({ title, detail }) => (
  <p key={title}>
    <span>{title}</span>: {detail}
  </p>
);

export const Cast = props => (
  <p>
    <span>Cast</span>: {props.cast.map(actor => actor + " | ")}
  </p>
);

export const RelatedWork = props => (
  <p>
    <span>Related work</span>:{" "}
    {props.relatedWorks.map(work => (
      <a key={work.name} href={work.url}>
        {work.name} |{" "}
      </a>
    ))}
  </p>
);

export const ProjectInfo = ({
  title,
  slug,
  images,
  info,
  cast,
  related_work,
  type
}) => (
  <Container id="project_info" className="pb-5 mb-5">
    <Row className="project-info">
      <Col xs="12" lg="6" className="text-center">
        <img
          src={images.poster}
          alt={slug}
          className={`img-fluid ${
            type === "advertisement"
              ? "project-info__ad__image"
              : "project-info__film__image"
          }`}
        />
      </Col>
      <Col xs="12" lg="6" className="pt-3 pb-2 project-info__details">
        <div>
          {Object.keys(info).map(key => (
            <Details key={key} title={key} detail={info[key]} />
          ))}
          {cast ? <Cast cast={cast} /> : null}
          {related_work ? <RelatedWork relatedWorks={related_work} /> : null}
        </div>
      </Col>
    </Row>
  </Container>
);
export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/components/ProjectPage/ProjectInfo/ProjectInfo.js